<template>
  <div class="title-box">
    <h2 class="title-box_title">Artworks</h2>
    <div class="title-box_right">
      <div class="title-box_right-content">
        <PublicSelect
          :items="sortData"
          :selected="selectedSort"
          @input="$emit('sort', $event)"
        ></PublicSelect>
        <FilterBlock
          style="margin-left: 15px"
          :items="filters"
          :search="search"
          @open="$emit('open-filters', $event)"
          @selectFilter="$emit('select-filter', $event)"
          @apply="$emit('apply-filters')"
          @clear="$emit('clear-filters')"
          @changeSearch="$emit('change-search', $event)"
        ></FilterBlock>
      </div>
    </div>
  </div>
</template>

<script>
import PublicSelect from "@/components/inputs/PublicSelect.vue";
import FilterBlock from "@/components/FilterPublic.vue";

export default {
  components: { PublicSelect, FilterBlock },
  props: {
    sortData: { type: Array, required: true },
    selectedSort: { type: [String, Number], required: true },
    filters: { type: Array, required: true },
    search: { type: String, required: true },
  },
};
</script>

<style lang="scss" scoped>
.title-box {
  @include titleFlexWrapper;

  &_right {
    @include rightActionsWrapper();
  }

  &_title {
    font-size: 40px;
    line-height: 1.25;
    @media screen and (max-width: $xs) {
      font-size: 35px;
      line-height: 1.23rem;
    }
  }
}
</style>

